<template>
  <div class="only-content">
    <div class="question">
      <div class="title-in-bg" v-if="question.settings.questionDisplayStyle == 1" v-bind:style="question.media != null ? {backgroundImage: 'url('+question.media.value.src+')',backgroundSize: 'cover',backgroundRepeat: 'no-repeat'} : {backgroundColor: question.settings.questionBackgroundColor}">
          <p :style="{color: question.settings.questionFontColor}">{{question.text}}</p>
      </div>
      <div class="title-out-bg" v-else-if="question.settings.questionDisplayStyle == 2">
          <p :style="{color: question.settings.questionFontColor}">{{question.text}}</p>
          <div class="img-question" v-if="question.media != null">
            <img :src="question.media.value.src" />
          </div>
      </div>
      <div class="title-only-image" v-else-if="question.settings.questionDisplayStyle == 3">
          <div class="img-question" v-if="question.media != null">
            <img :src="question.media.value.src" />
          </div>
      </div>
      <div class="title-only-text" v-else>
          <p :style="{color: question.settings.questionFontColor}">{{question.text}}</p>
      </div>
      
      <div class="wrap-answer" v-bind:class="[answer[index].data != null ? 'disable' : '', 'answer_'+ question.settings.optionDisplayColumn]" >
        <div 
          class="answer" 
          v-for="(value,key) in question.options" 
          v-bind:key="key"
          v-bind:class="[
            answer[index].data != null && answer[index].data.id == value.id  ? 'correct' : '',
          ]"
          @click="selectAnswer(question, value)"
        >
          <div 
            class="answer-text" 
            :style="{
              backgroundColor: value.settings.backgroundColor != '' ? value.settings.backgroundColor : question.settings.optionBackgroundColor, 
              border: value.settings.backgroundColor != '' ? '3px solid '+ value.settings.backgroundColor : '3px solid ' + question.settings.optionBackgroundColor}">
            <p :style="{color: value.settings.fontColor != null ? value.settings.fontColor : question.settings.optionFontColor, overflowWrap: 'anywhere'}">{{value.text}}</p>
          </div>
          <div class="icon-correct" v-if="answer[index].data != null && answer[index].data.id == value.id " >
            <Correct />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InCorrect from '../../ui/icons/svgs/icons/InCorrect'
import Correct from '../../ui/icons/svgs/icons/Correct'
export default {  
  name: "OnlyContent",
  props: ['question', 'index', 'showResult'],
  components: {
    InCorrect,
    Correct
  },
  computed: {
    answer: function(){
      return this.$store.getters.defaultAnswer
    }
  },
  methods: {
    selectAnswer(question, option){
      const infoOption = [question.id,option]
      this.$store.dispatch('chooseAnswer', infoOption);
    }
  }
};
</script>

<style lang="scss">
  .only-content{
    .title-in-bg{
      display: flex;
      align-items: center;
      border-radius: 8px;
      font-weight: bold;
      min-height: 116px;
      font-size: 32px;
      line-height: 36px;
      justify-content: center;
      text-align: center;
      padding: 44px 60px;
      color: #FFFFFF;
      margin-bottom: 10px;
    }
    .title-out-bg{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      border-radius: 8px;
      font-weight: bold;
      margin-bottom: 10px;
      color: #333333;
      justify-content: left;
      text-align: left;
      font-size: 26px;
      line-height: 31px;
      .img-question{
        width: 100%;
        margin-top: 10px;
        img{
          width: 100%;
          border-radius: 8px;
        }
      }
    }
    .title-only-image{
      width: 100%;
      margin-bottom: 10px;
      .img-question{
        width: 100%;
        img{
          width: 100%;
          border-radius: 8px;
        }
      }
    }
    .title-only-text{
      margin-bottom: 10px;
      p{
        font-weight: bold;
        font-size: 26px;
        line-height: 31px;
      }
    }
    
    .wrap-answer{
      display: grid;
      justify-content: space-between;
      grid-gap: 10px;
      .answer{
        display: flex;
        cursor: pointer;
        position: relative;
        border-radius: 13px;
        .answer-text{
          width: calc(100% - 6px);
          margin: auto;
          min-height: 104px;
          padding: 8px 0;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          line-height: 24px;
          color: #FFFFFF;
          text-align: center;
        }
        .icon-correct{
          background: #0F62FE;
          width: 24px;
          height: 24px;
          position: absolute;
          top: 10px;
          right: 10px;
          border-radius: 2px;
          display: none;
          align-items: center;
          justify-content: center;
          svg{
            width: 16px;
            fill: #fff;
          }
        }
      }
      .correct{
        .answer-text{
            border: 3px solid #0F62FE !important;
        }
        .answer-img{
            border: 3px solid #0F62FE;
        }
        .text-answer{
            border: 3px solid #0F62FE !important;
        }
        .icon-correct{
            display: flex;
        }
      }
    }
    .answer_4{
      grid-template-columns: repeat(2, 1fr);
      @media only screen and (min-width: 500px) {
        grid-template-columns: repeat(4, 1fr);
      }
    }
    .answer_3{
      grid-template-columns: repeat(3, 1fr);
    }
    .answer_2{
      grid-template-columns: repeat(2, 1fr);
    }
    .answer_1{
      grid-template-columns: repeat(1, 1fr);
      width: 100%;
      border-radius: 8px;
      .answer{
        // height: 44px;
        .answer-text{
          // height: calc(100% - 6px);
          // width: calc(100% - 6px);
          margin: auto;
          padding: 9px;
          min-height: unset;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 16px;
          line-height: 20px;
          text-align: center;
        }
      }
    }
    .disable{
      pointer-events: none;
    }
  }
  @media screen and (max-width: 768px) {
    .only-content .title-in-bg {
      font-size: 6vw;
      line-height: 140%;
      padding: 20px;
    }
  }
</style>